/**
 * Allow any parent scope to set the pristine state of the quickforms
 * by broadcasting 'set<FormName>Pristine'.
 *
 * Forms also emit '<formName>Pristine' when the pristine state changes.
 */
/**
 *  Module
 *
 * Description
 */
angular.module('jv.candidate.quickforms.controller', [])
    .controller('jvCandidateQuickFormController', ['$scope', '$element', function ($scope, $element) {
        $scope.isNewJQuery = parseFloat(jQuery.fn.jquery) > 1.7;
        var listen = function (formCtrl) {
            var name;
            if (formCtrl && formCtrl.$name) {
                name = formCtrl.$name.charAt(0).toUpperCase() + formCtrl.$name.substr(1);
                $scope.$on('set' + name + 'Pristine', function () {
                    // new version of angular has $setPristine, use when available
                    if (formCtrl.$setPristine) {
                        formCtrl.$setPristine();
                    } else {
                        $element.removeClass('ng-dirty').addClass('ng-pristine');
                        formCtrl.$pristine = true;
                        formCtrl.$dirty = false;
                        angular.forEach($element.find('.ng-dirty'), function (el) {
                            var inputCtrl = $(el).data('$ngModelController');
                            if (inputCtrl) {
                                inputCtrl.$pristine = true;
                                inputCtrl.$dirty = false;
                                $(el).removeClass('ng-dirty').addClass('ng-pristine');
                            }
                        });
                    }
                });
            }
        };
        $scope.$watch('messageForm', listen);
        $scope.$watch('noteForm', listen);
        $scope.$watch('messageForm.$pristine', function (val) {
            $scope.$emit('messageFormPristine', val);
        });
        $scope.$watch('noteForm.$pristine', function (val) {
            $scope.$emit('noteFormPristine', val);
        });
    }]);